"use client";

import { c as _c } from "react/compiler-runtime";
import { ChatConfigContext, type ChatConfigContextValue, ChatFilterContext, type ChatFilterContextValue, ChatInputContext, type ChatInputContextValue, ChatModalsRefContext, type ChatModalsRefContextValue, ChatScrollRefContext, type ChatScrollRefContextValue, ChatSuggestionsContext, type ChatSuggestionsContextValue, useChatConfigContext, useChatFilterContext, useChatInputContext, useChatModalsRefContext, useChatScrollRefContext, useChatSuggestionsContext } from "./contexts";

// Re-export sub-contexts for direct access
export { ChatConfigContext, useChatConfigContext, useChatFilterContext, useChatInputContext, useChatModalsRefContext, useChatScrollRefContext, useChatSuggestionsContext };

// Provider component that composes all sub-contexts
// Sub-context values should be pre-memoized by the parent (ChatRoot)
interface ChatProviderProps {
  children: React.ReactNode;
  // Pre-memoized sub-context values
  configValue: ChatConfigContextValue;
  inputValue: ChatInputContextValue;
  suggestionsValue: ChatSuggestionsContextValue;
  filterValue: ChatFilterContextValue;
  // Ref contexts
  modalsRefValue: ChatModalsRefContextValue;
  scrollRefValue: ChatScrollRefContextValue;
}
export function ChatProvider(t0) {
  const $ = _c(18);
  const {
    children,
    configValue,
    inputValue,
    suggestionsValue,
    filterValue,
    modalsRefValue,
    scrollRefValue
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== scrollRefValue) {
    t1 = <ChatScrollRefContext.Provider value={scrollRefValue}>{children}</ChatScrollRefContext.Provider>;
    $[0] = children;
    $[1] = scrollRefValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== modalsRefValue || $[4] !== t1) {
    t2 = <ChatModalsRefContext.Provider value={modalsRefValue}>{t1}</ChatModalsRefContext.Provider>;
    $[3] = modalsRefValue;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== filterValue || $[7] !== t2) {
    t3 = <ChatFilterContext.Provider value={filterValue}>{t2}</ChatFilterContext.Provider>;
    $[6] = filterValue;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== suggestionsValue || $[10] !== t3) {
    t4 = <ChatSuggestionsContext.Provider value={suggestionsValue}>{t3}</ChatSuggestionsContext.Provider>;
    $[9] = suggestionsValue;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== inputValue || $[13] !== t4) {
    t5 = <ChatInputContext.Provider value={inputValue}>{t4}</ChatInputContext.Provider>;
    $[12] = inputValue;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== configValue || $[16] !== t5) {
    t6 = <ChatConfigContext.Provider value={configValue}>{t5}</ChatConfigContext.Provider>;
    $[15] = configValue;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}